import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { TrainingFollowUpTrainingItemVM } from "@shared-kernel/application/ports/admin/admin-repository";

export const adminRetrieveTrainingItems = createAsyncThunk<TrainingFollowUpTrainingItemVM[], string, { extra: Partial<Dependencies> }>(
  "trainingFollowUps/adminRetrieveTrainingItems",
  async (trainingFollowUpId: string, { extra: { adminRepository } }) => {
    return adminRepository!.getTrainingItems(trainingFollowUpId);
  },
);
